import gql from 'graphql-tag';

import duplicateFileFragment from './duplicateFileFragment';

export const duplicateFilesPageFragment = gql`
  fragment duplicateFilesPageFragment on DuplicateFilesPage {
    dokkioClass
    total
    duplicateFiles {
      ...duplicateFileFragment
    }
  }
  ${duplicateFileFragment}
`;
export default duplicateFilesPageFragment;
